import PressThumbDescription from "../../../../src/courses/partials/services/pressthumb.mdx";
import * as React from 'react';
export default {
  PressThumbDescription,
  React
};